import {
  ClickAwayListener,
  Grow,
  IconButton,
  Paper,
  Popper as MUIPopper,
  Tooltip,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useRef, useState } from 'react';
import type { ReactNode } from 'react';
import { SeriesSettingsIcon } from '@/shared/ui';

const Popper = styled(MUIPopper)(({ theme }) => ({
  zIndex: theme.zIndex.modal,
}));

interface Props {
  disabled?: boolean;
  disabledReason?: string;
  ariaLabel: string;
  children: ReactNode;
}

export function AxisSeriesMenuButton({
  disabled,
  disabledReason,
  ariaLabel,
  children,
}: Props) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);

  const button = (
    <IconButton
      ref={anchorRef}
      aria-label={ariaLabel}
      disabled={disabled}
      sx={{
        width: 40,
        height: 40,
        border: '1px solid',
        borderColor: open ? 'primary.main' : 'rgba(0, 0, 0, 0.23)',
        borderRadius: 2,
        color: open ? 'primary.main' : '#343844',
        backgroundColor: open ? '#EBEFFF' : 'transparent',
      }}
      onClick={() => setOpen((wasOpen) => !wasOpen)}
    >
      <SeriesSettingsIcon sx={{ fontSize: 20 }} />
    </IconButton>
  );

  return (
    <>
      {disabled && disabledReason ? (
        <Tooltip arrow title={disabledReason}>
          <span>{button}</span>
        </Tooltip>
      ) : (
        button
      )}
      {open && (
        <Popper
          open
          anchorEl={anchorRef.current}
          placement="bottom-end"
          transition
        >
          {({ TransitionProps }) => (
            <Grow {...TransitionProps} style={{ transformOrigin: 'right top' }}>
              <Paper sx={{ mt: 0.5 }} elevation={3}>
                <ClickAwayListener onClickAway={() => setOpen(false)}>
                  <div>{children}</div>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      )}
    </>
  );
}
